import(/* webpackMode: "eager" */ "/home/runner/work/phpreaction-frontend-inventory-react/phpreaction-frontend-inventory-react/src/app/global-error.tsx");
